export default __webpack_public_path__ + "static/media/insight.3f486dd5.svg";